export default "__VITE_ASSET__BqfQgF7E__"